import { useMutation } from '@tanstack/react-query'
import {
  registerFCMDevice,
  sendTestFCM,
  unregisterFCMDevice,
} from '../api/react/notifications/devices'

export const useRegisterFCMDevice = () =>
  useMutation({
    mutationFn: registerFCMDevice,
  })

export const useUnregisterFCMDevice = () =>
  useMutation({
    mutationFn: unregisterFCMDevice,
  })

export const useSendTestFCM = () =>
  useMutation({
    mutationFn: sendTestFCM,
  })
